.root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--mantine-color-gray-0);
}

.main {
  flex: 1;
  width: 100%;
}
